import { Provider } from "react-redux";
import { AuthProvider } from "@/context/providers/AuthProvider";
import { OrganizationProvider } from "@/context/providers/OrganizationProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import AppRoutes from "@/routes";
import { store } from "@/state/store";

const App = () => {
    return (
        <Provider store={store}>
            <OrganizationProvider>
                <AuthProvider>
                    <TooltipProvider>
                        <AppRoutes />
                    </TooltipProvider>
                </AuthProvider>
            </OrganizationProvider>
        </Provider>
    );
};

export default App;
